﻿import { RefObject, useCallback } from 'react';
import { ButtonRef, FnWithNumberInput } from '../Types';
import { useSliderContext } from '../SliderContext';

type UseNavigationProps = {
  nextButton?: ButtonRef;
  previousButton?: ButtonRef;
  groupSize: RefObject<number>
  beforeChange: FnWithNumberInput
  buttonDisabledClasses: string
}

const useNavigation = (
  {
    beforeChange,
    previousButton,
    nextButton,
    buttonDisabledClasses
  }: UseNavigationProps) => {

  const { index, tiles, groupSize, setForceUpdate } = useSliderContext();

  const updateIndex = useCallback((newIndex: number, forceUpdate = true) => {
    if (!tiles.current) return;

    newIndex = Math.max(0, Math.min(tiles.current.length - groupSize.current, newIndex));
    if (newIndex === index.current) return;

    index.current = newIndex;
    beforeChange(newIndex);
    if (forceUpdate) setForceUpdate((prev) => prev + 1);
  }, [setForceUpdate, beforeChange, groupSize, index, tiles]);

  const toggleButtonClasses = useCallback(() => {
    if (!nextButton?.current || !previousButton?.current || !buttonDisabledClasses || !tiles.current || !groupSize.current) return;

    previousButton.current.classList[index.current === 0 ? 'add' : 'remove'](...buttonDisabledClasses.split(' '));
    nextButton.current.classList[index.current === tiles.current.length - groupSize.current ? 'add' : 'remove'](...buttonDisabledClasses.split(' '));
  }, [buttonDisabledClasses, nextButton, previousButton, groupSize, index, tiles]);

  return {
    updateIndex,
    toggleButtonClasses
  };
};

export default useNavigation;